import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserCard from './UserCard';
import { FaHeart, FaTimes, FaCog } from 'react-icons/fa';
import './CardFlowPage.css'; // 导入独立的CSS文件
// 修改导入部分，从femaleData.js导入
import femaleData from '../data/femaleData';
//femalData每个对象包含的字段
//self_sex,self_job,self_screen_name,self_age,self_height,self_appearance,self_skin,self_personality,self_annual_income,self_property,self_education,self_parent_education,self_drinking,self_smoking,req_appearance,req_skin,req_height_min,req_height_max,req_age_min,req_age_max,req_personality,req_annual_income_min,req_property,req_education_min,req_parent_education_min,req_drinking,req_smoking
//self开头代表该用户自己的信息，req开头代表该用户对另一半的要求

function CardFlowPage({ strictConditions, flexibleConditions }) {
  console.log('strictConditions:', strictConditions);
  console.log('flexibleConditions:', flexibleConditions);
  const [users, setUsers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // 修改加载数据的useEffect
  useEffect(() => {
    const loadUserData = async () => {
      try {
        setIsLoading(true);
        
        // 直接使用导入的femaleData
        console.log('原始数据前10行:', femaleData.slice(0, 10));
        console.log('数据总行数:', femaleData.length);
        
        const filteredAndSortedUsers = filterAndSortUsers(femaleData);
        setUsers(filteredAndSortedUsers);
        
        console.log('过滤排序后数据前10行:', filteredAndSortedUsers.slice(0, 10));
        console.log('过滤后数据总行数:', filteredAndSortedUsers.length);
        
        setIsLoading(false);
      } catch (error) {
        console.error('加载用户数据失败:', error);
        setIsLoading(false);
      }
    };

    loadUserData();
  }, [strictConditions, flexibleConditions]);

  // 根据条件过滤和排序用户
  const filterAndSortUsers = (userData) => {
    // 1. 首先过滤出符合卡死条件的用户
    let filteredUsers = userData.filter(user => {
      return strictConditions.every(condition => {
        return matchesCondition(user, condition);
      });
    });

    // 2. 然后根据符合宽松条件的数量进行排序
    filteredUsers.sort((a, b) => {
      const aMatches = flexibleConditions.filter(condition => 
        matchesCondition(a, condition)
      ).length;
      
      const bMatches = flexibleConditions.filter(condition => 
        matchesCondition(b, condition)
      ).length;
      
      return bMatches - aMatches; // 降序排列，符合条件多的排前面
    });

    return filteredUsers;
  };

  // 检查用户是否符合特定条件
  const matchesCondition = (user, condition) => {
    const { key, rawValue } = condition;
    
    switch (key) {
      case 'appearance':
        // 外貌条件匹配
        if (rawValue === '至少不难看') {
          return user.self_appearance >= 2; // 一般或好看
        } else if (rawValue === '必须好看') {
          return user.self_appearance === 3; // 好看
        }
        return true;
      
      case 'height_min':
        return user.self_height >= parseInt(rawValue);
      
      case 'height_max':
        return user.self_height <= parseInt(rawValue);
      
      case 'age_min':
        return user.self_age >= parseInt(rawValue);
      
      case 'age_max':
        return user.self_age <= parseInt(rawValue);
      
      case 'annual_income_min':
        return user.self_annual_income >= parseInt(rawValue);
      
      case 'personality':
        if (rawValue === '内向') return user.self_personality === 'i';
        if (rawValue === '外向') return user.self_personality === 'e';
        return true;
      
      case 'property':
        return rawValue === '必须有房' ? user.self_property === 1 : true;
      
      case 'education_min':
        const educationLevels = { '高中': 2, '本科': 3, '硕士': 4, '博士': 4 };
        return user.self_education >= educationLevels[rawValue];
      
      case 'parent_education_min':
        const parentEducationLevels = { '高中': 2, '本科': 3, '硕士': 4, '博士': 4 };
        return user.self_parent_education >= parentEducationLevels[rawValue];
      
      case 'drinking':
        if (rawValue === '只接受从不') return user.self_drinking === 0;
        if (rawValue === '能接受偶尔') return user.self_drinking <= 1;
        return true;
      
      case 'smoking':
        if (rawValue === '只接受从不') return user.self_smoking === 0;
        if (rawValue === '能接受偶尔') return user.self_smoking <= 1;
        return true;
      
      default:
        return true;
    }
  };

  // 处理喜欢按钮点击
  const handleLike = () => {
    // 在实际应用中，这里可以发送喜欢请求到后端
    console.log('喜欢用户:', users[currentIndex]);
    goToNextCard();
  };

  // 处理不喜欢按钮点击
  const handleDislike = () => {
    // 在实际应用中，这里可以发送不喜欢请求到后端
    console.log('不喜欢用户:', users[currentIndex]);
    goToNextCard();
  };

  // 前往下一张卡片
  const goToNextCard = () => {
    if (currentIndex < users.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // 所有卡片都已浏览完
      setCurrentIndex(-1); // 设置为-1表示没有更多卡片
    }
  };

  // 前往标签页调整条件
  const goToTagsPage = () => {
    navigate('/tags', {
      state: {
        strictConditions,
        flexibleConditions
      }
    });
  };

  return (
    <div className="card-flow-container">
      <h1 className="title">推荐用户</h1>
      {!isLoading && users.length > 0 && currentIndex !== -1 && (
        <div className="remaining-count">
          {users.length - currentIndex}
        </div>
      )}
      
      {isLoading ? (
        <div className="loading-state">加载中...</div>
      ) : users.length === 0 ? (
        <div className="no-matches">
          <h2>没有符合您条件的用户</h2>
          <p>请调整您的筛选条件试试</p>
          <button className="button" onClick={goToTagsPage}>
            调整条件
          </button>
        </div>
      ) : currentIndex === -1 ? (
        <div className="no-more-cards">
          <h2>已浏览完所有推荐用户</h2>
          <button className="button" onClick={() => setCurrentIndex(0)}>
            重新浏览
          </button>
        </div>
      ) : (
        <div className="card-container">
          <UserCard userData={users[currentIndex]} />
          
          <div className="card-actions">
            <button className="action-button dislike-button" onClick={handleDislike}>
              <FaTimes />
            </button>
            <button className="action-button like-button" onClick={handleLike}>
              <FaHeart />
            </button>
          </div>
        </div>
      )}
      
      <button className="settings-button" onClick={goToTagsPage}>
        <FaCog />
      </button>
    </div>
  );
}

export default CardFlowPage;